import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
Vue.use(Vuex)

let ls = new SecureLS({
	encodingType: 'aes',
	isCompression: false,
	encryptionSecret: "old-beauty"
})
export default new Vuex.Store({
	plugins: [
		createPersistedState({
			key: 'xdsb',
			storage: {
				getItem: key => ls.get(key),
				setItem: (key, value) => ls.set(key, value),
				removeItem: key => ls.remove(key)
			}
		})
	],
	// state: {
	// 	WX_STATE: 0,
	// 	ISZ:'',
	// 	USER_ID: '',
	// 	SELLER_ID:'',
	// 	I_SHOP: '',
	// 	I_EVEL: '',
	// 	HEAD_IMG: '',
	// 	USER_NAME: '',
	// 	ROOT_URL: 'https://www.zlqt.zlqthb.com/', //测试
	// 	IMG_URL: 'https://img.zlqthb.com', //图片
	// 	BASE_URL: 'https://www.zlqt.zlqthb.com', //
	// 	USER_URL: 'https://www.zlqt.zlqthb.com/',
	// 	HIMG_URL: 'https://www.zlqt.zlqthb.com/',
	//     VIDEO_URL:'https://api.hbchanyelian.com',
	// 	VID_URL:'http://mstsc.zlqthb.com:8013/api/seller/',
	// 	HAHA_URL:'http://192.168.1.97:8013'
	// },
	 state: {
		WX_STATE: 0,
		FLAGSHIP:0,
		QJEND:'',
		QJSTART:'',
		ISZ:'',
		USER_ID: '',
		SELLER_ID:'',
		I_SHOP: '',
		I_EVEL:'',
		HEAD_IMG: '',
		USER_NAME: '',
		ROOT_URL: 'https://www.hbchanyelian.com/',
		IMG_URL: 'https://img.hbchanyelian.com/',
		BASE_URL: 'https://www.hbchanyelian.com/',
		USER_URL: 'https://www.hbchanyelian.com/',
		HIMG_URL:'https://himg.chinaxdsb.com/',
		VIDEOIMG_URL:'https://img2.hbchanyelian.com/',
		VIDEO_URL:'https://api.hbchanyelian.com',
		VID_URL:'https://api.hbchanyelian.com/api/seller/',
	 },
	mutations: {
		SET_WX_STATE(state, value) {
			state.WX_STATE = value
		},
		SET_SELLER_ID(state, value) {
			state.SELLER_ID= value
		},
		SET_FLAGSHIP(state, value) {
			state.FLAGSHIP= value
		},
		SET_ISZ(state, value) {
			state.ISZ= value
		},
		SET_USER_ID(state, value) {
			state.USER_ID = value
		},
		SET_I_SHOP(state, value) {
			state.I_SHOP = value
		},
		SET_I_EVEL(state, value) {
			state.I_EVEL = value
		},
		SET_RAND_ID(state, value) {
			state.RAND_ID = value
		},
		SET_TYPE_ID(state, value) {
			state.TYPE_ID = value
		},
		SET_VIP(state, value) {
			state.VIP = value
		},
		SET_UPHONE(state, value) {
			state.UPHONE = value
		},
		SET_CNAME(state, value) {
			state.CNAME = value
		},
		SET_HEAD_IMG(state, value) {
			state.HEAD_IMG = value
		},
		SET_USER_NAME(state, value) {
			state.USER_NAME = value
		},
		SET_I_EVEL(state, value) {
			state.I_EVEL = value
		},
		SET_QJEND(state, value) {
			state.QJEND = value
		},
		SET_QJSTART(state, value) {
			state.QJSTART = value
		}
	},
})
